import React from 'react';

function ErrorModal({
  isOpen,
  onClose,
  title = 'Error',
  message = 'An error occurred',
  buttonText = 'Okay',
  type = 'error' // 'error', 'warning', 'info', 'success'
}) {
  if (!isOpen) return null;

  const getIcon = () => {
    switch (type) {
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      case 'success': return '✅';
      default: return '❌';
    }
  };

  const getColor = () => {
    switch (type) {
      case 'warning': return '#ff9500';
      case 'info': return '#007bff';
      case 'success': return '#28a745';
      default: return '#e74c3c';
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2 style={{ color: getColor() }}>
          {getIcon()} {title}
        </h2>
        <div style={{ 
          lineHeight: '1.6',
          marginBottom: '1.5rem',
          color: '#ffffff',
          textAlign: 'left'
        }}>
          {typeof message === 'string' ? (
            <p>{message}</p>
          ) : (
            message
          )}
        </div>
        <div className="modal-buttons" style={{ marginTop: '1rem' }}>
          <button
            className="rainbowBtn"
            onClick={onClose}
            style={{ 
              backgroundColor: getColor(),
              border: 'none',
              width: '100%'
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default ErrorModal; 